import { Component, Input,ElementRef,ViewChild,Output,EventEmitter } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import {ActivatedRoute} from '@angular/router';
import { Platform } from '@ionic/angular';
import { MapclientServiceService } from '../../../../service/mapclient.service.service';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import {BaseModal} from '../../../../model/base';
import {WebParameterContext} from '../../../../model/common';
import { CommonService } from '../../../../service/common.service';
declare var app;
@Component({
  selector: 'app-nearbystore',
  templateUrl: './nearbystore.component.html',
  styleUrls: ['./nearbystore.component.scss']
})
export class NearbystoreComponent extends GridBaseCase {
  @ViewChild('nearbystoremap') map_container:ElementRef;
  @Input() data: any;//接收父组件的值
  @Output() private childOuterEvent = new EventEmitter();
  constructor(
    private platform:Platform,
    private activaRouter: ActivatedRoute,
    private map:MapclientServiceService,
    private msg:MessageclientService,
    private http: HttpCustomerService,
    public base:BaseModal,
    public com: CommonService
  ) {super(); }

  ngOnInit() {
  }
  ngOnChanges(){
    // console.log("505"+this.data);
    this.location();
    
    }
  location() {
    console.log(this.element);
    
    let that = this;
    that.childOuterEvent.emit([]);
   
      // that.map.Geolocation(that.map_container.nativeElement).then(data=>{
      //   loading.dismiss();
      //   console.log(data);
      //    that.msg.Show(data,"top");
      // }).catch(error=>{
      //   loading.dismiss();
      //   that.msg.Show(error.message,"top");
      // })
      if(that.platform.is("cordova")){
          that.map.getGDCurrentPosition().then(option=>{
            that.msg.Loading("定位中...").then((loading)=>{
            that.map.getMaplocation(that.map_container.nativeElement).then(data=>{
              // console.log(data);
              loading.dismiss();
              if(data.msg){
              }
              if(app.MARKER){//启用定位锚点
                that.getmendianlocation(data);
              }
            }).catch(error=>{  
              loading.dismiss();
              console.log(error);
              that.childOuterEvent.emit([]);
                that.msg.Alert("定位失败,请切换网络,或者打开gps定位功能");
              //TODO:
              // that.getmendianlocation({});
            });
            loading.present();
          });
        }).catch(err=>{
          that.childOuterEvent.emit([]);
          that.msg.Alert("定位失败,请切换网络,或者打开gps定位功能");
        });
      }else{
        that.msg.Loading("定位中...").then((loading)=>{
        that.map.getMaplocation(that.map_container.nativeElement).then(data=>{
          // console.log(data);
          loading.dismiss();
          if(data.msg){
          }
          if(app.MARKER){//启用定位锚点
            that.getmendianlocation(data);
          }
        }).catch(error=>{  
          loading.dismiss();
          console.log(error);
          that.childOuterEvent.emit([]);
            that.msg.Alert("定位失败,请切换网络,或者打开gps定位功能");
          //TODO:
          // that.getmendianlocation({});
        });
        loading.present();
          });
        
      }
      
    
     
  // that.map.getMaplocation(that.map_container.nativeElement).then(data=>{
  //   console.log(data);
    
  // }).catch(error=>{  
  //   console.log(error);
  //      that.singInmsg = "定位失败,请联系管理员";
  //     that.msg.Show(error.message,"top",true,100000);
  // });
  //that.map.WalkingOptionLine(that.map_container.nativeElement,"");
 
}
getmendianlocation(data:any){
const that = this;
const maps = data.map;
const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
let body = new WebParameterContext();
// body.ConfigName = "UnselectedStoreOrDealer";
if (that.element.selectItemList.gridViewConfigName) {
  body.ConfigName = that.element.selectItemList.gridViewConfigName;
} else if (that.ConfigName) {
  body.ConfigName = that.ConfigName;
}
body.OpType = "query";
body.ConfigType = "view";
// body.RowsPerPage = 2;
body.Client.PageName = PageName;
body.Client.ApiType = "Element";
body.Client.Name = that.element.name;
body.Client.ClientType = 2;
if (that.platform.is("android")) {
  body.Client.ClientType = 0;
} else if (that.platform.is("ios")) {
  body.Client.ClientType = 1;
}
body.RequestBody= JSON.stringify({"userId":that.com.GetAccount.Id,"longitude":data.position.lng,"latitude":data.position.lat});
that.msg.Loading("正在努力的查找附近门店...").then((load)=>{
  that.http.post(app.DEFAULTURL, body).then(data => {
    load.dismiss();
    if (data.ResponseMessage.Success) {
      let dataArray = [];
        data.Status.Datas.forEach(function (items) {
          let marker= that.map.drawMarker(items.longitude,items.latitude,items.Name);
          maps.add(marker);
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if(element.bindingField){
              objfield[element.bindingField] = {"value":items[element.field],"text":element.text};
            }
          });
          dataArray.push(objfield);
        // console.log(that.element.selectItemList.selectItem);
      });
      that.childOuterEvent.emit(dataArray);
      // const option:Array<Array<string>>=[[]];
      // data.Status.Datas.forEach((items,index)=>{
      
      // });
    }
  }).catch(error => {
    load.dismiss();
    that.msg.Show(error);
  });
  load.present();
}).catch((error)=>{
  console.log(error);
});
}
}
